export const COMPLETE = 'complete';
export const INPROGRESS = 'in-progress';
export const REJECTED = 'rejected';
export const WAITING = 'waiting';
export const NOTSIGNED = 'not_signed';
